import { createQueryKeys } from '@lukemorales/query-key-factory';

export const uaeJoin = createQueryKeys('uaeJoin', {
  mine: null,
  adminList: (filters: Record<string, string>) => [filters],
  adminDetail: (agentProfileId: string) => [agentProfileId],
});
